module.exports = __webpack_public_path__ + "img/f4-3-1.15b63e9b.png";